"use client"

import { useContext, useRef, useState } from "react"
import type { Account } from "better-auth"
import { AuthUIContext } from "../../../lib/auth-ui-provider"
import type { AuthLocalization } from "../../../localization/auth-localization"
import type { SettingsCardClassNames } from "../shared/settings-card"
import { SettingsCard } from "../shared/settings-card"
import { DeleteAccountDialog } from "./delete-account-dialog"

export interface DeleteAccountCardProps {
    className?: string
    classNames?: SettingsCardClassNames
    accounts?: Account[] | null
    isPending?: boolean
    localization?: AuthLocalization
    skipHook?: boolean
}

export function DeleteAccountCard({
    className,
    classNames,
    accounts,
    isPending,
    localization,
    skipHook
}: DeleteAccountCardProps) {
    const {
        hooks: { useListAccounts },
        localization: contextLocalization
    } = useContext(AuthUIContext)

    localization = { ...contextLocalization, ...localization }

    const [showDialog, setShowDialog] = useState(false)
    const actionButton = useRef<HTMLButtonElement>(null)

    if (!skipHook) {
        const result = useListAccounts()
        accounts = result.data
        isPending = result.isPending
    }

    return (
        <div>
            <SettingsCard
                className={className}
                classNames={classNames}
                actionLabel={localization?.DELETE_ACCOUNT}
                description={localization?.DELETE_ACCOUNT_DESCRIPTION}
                isPending={isPending}
                title={localization?.DELETE_ACCOUNT}
                variant="destructive"
                action={() => setShowDialog(true)}
                actionButtonRef={actionButton}
            />

            <DeleteAccountDialog
                classNames={classNames}
                accounts={accounts}
                localization={localization}
                open={showDialog}
                onOpenChange={setShowDialog}
                onCloseAutoFocus={(event) => { event.preventDefault(); actionButton.current?.focus() }}
            />
        </div>
    )
}
